module.exports = __webpack_public_path__ + "static/media/pakistan-post.c2af1690.svg";